/**
 * GiftListPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  SelectDepth,
} from 'components';
import { Button, DatePicker, Input, Select } from 'antd';
import moment from 'moment';
import { stringToMoneyFormat } from 'utils';

const depthItem = [1, 2, 3, 4, 5].map((_i1) => ({
  key: `${_i1}`,
  title: `대분류 ${_i1}`,
  children: [1, 2, 3, 4, 5].map((_i2) => ({
    key: `${_i1}-${_i2}`,
    title: `중분류 ${_i1}-${_i2}`,
    children: [1, 2, 3, 4, 5].map((_i3) => ({
      key: `${_i1}-${_i2}-${_i3}`,
      title: `중소분류 ${_i1}-${_i2}-${_i3}`,
      children: [1, 2, 3, 4, 5].map((_i4) => ({
        key: `${_i1}-${_i2}-${_i3}-${_i4}`,
        title: `소분류 ${_i1}-${_i2}-${_i3}-${_i4}`,
      })),
    })),
  })),
}));

const GiftListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [selectedKey, setSelectedKey] = useState([]);
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '기간',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '입점업체',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[{ label: '전체', value: '전체' }]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Input
              size="large"
              style={{ ...styles.form.input.large }}
              placeholder="검색어를 입력해주세요"
            />
          ),
        },
      ],
    },
    {
      label: '상품 명',
      form: [
        {
          input: (
            <Input
              size="large"
              options={[{ label: '전체', value: '전체' }]}
              style={{ ...styles.form.input.large }}
              placeholder={'상품명을 입력해주세요'}
            />
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  const newData = [
    {
      결제일: moment(),
      상품명: '에스프레소 블렌드 원두 1kg',
      업체명: 'ABC원두',
      카테고리: '원두',
      금액: '32500',
      주문번호: '98765432198765',
    },
  ];
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>선물 내역 관리</Title>
          <Content maxWidth={'100%'} borderRadius={4}>
            <div>
              <Select
                size="large"
                value={'카테고리 검색으로 변경'}
                style={{ ...styles.form.input.large }}
              />
              <Input
                size="large"
                placeholder="카테고리명을 입력해주세요."
                style={{ ...styles.form.input.large, width: 400 }}
              />
            </div>

            <div style={{ marginTop: 20 }}>
              <SelectDepth
                items={depthItem}
                onSelect={(data) => setSelectedKey(data)}
                onFinish={({ title }) => console.log('finish', title)}
              />
            </div>
          </Content>

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{
                  ...styles.button,
                  background: 'var(--primary-color)',
                }}
              >
                검색
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색결과 */}
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
              검색 결과 총 <span>0</span>건
            </h4>
            <Table
              data={newData}
              columns={[
                {
                  title: '결제일시',
                  key: '결제일시',
                  render: (_item) =>
                    moment(_item).format('YYYY-MM-DD HH:mm:ss'),
                },
                {
                  title: '상품 명',
                  key: '상품명',
                },
                {
                  title: '업체 명',
                  key: '업체명',
                },
                {
                  title: '카테고리',
                  key: '카테고리',
                },
                {
                  title: '금액',
                  key: '금액',
                  render: (item) => stringToMoneyFormat(item),
                },
                {
                  title: '주문번호',
                  key: '주문번호',
                },
                /* {
                    title: '이름',
                    key: '이름',
                  },
                  {
                    title: '결제수단',
                    key: '결제수단',
                  },
                  {
                    title: '플랫폼',
                    key: '플랫폼',
                  }, */
              ]}
            />
          </Content>
          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default GiftListPresenter;
